import React, { useState } from "react";
import { FileSpreadsheet, Download, Calendar, Loader2 } from "lucide-react";
import apiService from "../services/api";
import "../styles/GoldCleanReport.css";

const GoldCleanReport = () => {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Generate month options for the last 12 months
  const getMonthOptions = () => {
    const options = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const value = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      const label = date.toLocaleDateString("he-IL", {
        year: "numeric",
        month: "long",
      });
      options.push({ value, label });
    }
    return options;
  };

  const handleExport = async () => {
    if (!selectedMonth) {
      setError("יש לבחור חודש");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await apiService.exportGoldCleanReport(selectedMonth);

      // Create blob and download
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `gold_clean_report_${selectedMonth.replace("-", "_")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error("Export error:", err);
      setError(err.message || "שגיאה בייצוא הקובץ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='gold-clean-report-container'>
      <div className='report-header'>
        <div className='header-icon'>
          <FileSpreadsheet size={32} />
        </div>
        <div className='header-text'>
          <h1>דוח Gold Clean</h1>
          <p>ייצוא דוח אקסל לפי אתרים וחודש</p>
        </div>
      </div>

      <div className='report-card'>
        <div className='card-content'>
          <div className='form-section'>
            <label className='form-label'>
              <Calendar size={18} />
              בחר חודש
            </label>
            <select
              className='month-select'
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              disabled={loading}
            >
              {getMonthOptions().map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className='info-section'>
            <h3>הדוח כולל:</h3>
            <ul>
              <li>
                <strong>גיליון ריכוז סכומים</strong> - סיכום לפי אתר
              </li>
              <li>
                <strong>גיליון מרכז</strong> - כל העובדים באזור המרכז
              </li>
              <li>
                <strong>גיליון דרום</strong> - כל העובדים באזור הדרום
              </li>
              <li>
                <strong>גיליונות לפי אתר</strong> - גיליון נפרד לכל אתר
              </li>
            </ul>
          </div>

          {error && <div className='error-message'>{error}</div>}

          {success && <div className='success-message'>הקובץ הורד בהצלחה!</div>}

          <button
            className='export-button'
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 size={20} className='spinner' />
                מייצא...
              </>
            ) : (
              <>
                <Download size={20} />
                ייצא לאקסל
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoldCleanReport;
